export default {
      id: "visa-lg-usage",
      viewBox: "0 0 47 13",
      url: __webpack_public_path__ + "svgsprite.svg#visa-lg",
      toString: function () {
        return this.url;
      }
    }